export default __webpack_public_path__ + "static/media/avatar-2.422bf125.jpg";